import { RefreshCw, X } from 'lucide-react';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useNewVersion } from '../updates';

/** A small bar at the foot of the screen once a new deploy is live: Refresh loads it. Staff also get What's new. */
export default function UpdateBanner({ changelog = false }: { changelog?: boolean }) {
  const ready = useNewVersion();
  const [hidden, setHidden] = useState(false);
  if (!ready || hidden) return null;
  return (
    <div className="update-banner" role="status">
      <span>A new version of NOLA is ready.</span>
      {changelog && <Link to="/settings#changelog" onClick={() => setHidden(true)}>What's new</Link>}
      <button type="button" className="button primary" onClick={() => window.location.reload()}><RefreshCw aria-hidden="true" />Refresh</button>
      <button type="button" className="icon-button" aria-label="Hide until later" title="Hide" onClick={() => setHidden(true)}><X aria-hidden="true" /></button>
    </div>
  );
}
